import {
  FILE_UPLOAD_ESN_MAPPING_SUCCESS,
  OVERLAY_MODAL_ESN_CLOSE,
  OVERLAY_MODAL_ESN_OPEN,
  SET_FILE_TO_UPLOAD,
  UploadModalAction,
  UploadModalState
} from './types';

const initialState: UploadModalState = {
  active: false,
  disabledUpload: true,
  dataUpload: new FormData(),
  fileNameToUpload: ''
};

export default function(state = initialState, action: UploadModalAction) {
  switch (action.type) {
    case OVERLAY_MODAL_ESN_CLOSE:
      return {
        ...state,
        active: false
      };
    case OVERLAY_MODAL_ESN_OPEN:
      return {
        ...state,
        active: true,
        title: action.payload.title,
        execute: action.payload.execute,
        fileNameToUpload: 'esn_mapping.label_choose_csv_file',
        dataUpload: new FormData(),
        disabledUpload: true,
        uploadResponse: ''
      };
    case SET_FILE_TO_UPLOAD:
      return {
        ...state,
        active: true,
        disabledUpload: !action.payload.get('file'),
        fileNameToUpload: action.payload.get('file').name
      };
    case FILE_UPLOAD_ESN_MAPPING_SUCCESS:
      return {
        ...state,
        uploadResponse: action.payload
      };
    default:
      return state;
  }
}
